import { create } from "zustand";
import { WebchatCallRequestState, WebchatCallRequestActions } from "./types";

// Once the customer accepts, the bot rings the agent for up to ~2 min (backend AcceptedTimeout).
// Keep the request tracked for at least that long so the Start button stays blocked; this is only
// a client-side fallback expiry for the case where the active/expired notification is missed.
const ACCEPTED_RING_FALLBACK_MS = 130_000;

export const useWebchatCallRequestStore = create<
	WebchatCallRequestState & WebchatCallRequestActions
>((set, get) => ({
	pendingByConversationId: {},
	setPending: (conversationId: string, requestId: string, expiresAt: string) =>
		set((state) => ({
			pendingByConversationId: {
				...state.pendingByConversationId,
				[conversationId]: { requestId, expiresAt, accepted: false },
			},
		})),
	clearPending: (conversationId: string) =>
		set((state) => {
			const { [conversationId]: _, ...rest } = state.pendingByConversationId;

			return { pendingByConversationId: rest };
		}),
	clearByRequestId: (requestId: string) => {
		const entry = Object.entries(get().pendingByConversationId).find(
			([, candidate]) => candidate.requestId === requestId
		);

		if (!entry) {
			return undefined;
		}

		get().clearPending(entry[0]);

		return entry[0];
	},
	markAccepted: (requestId: string) => {
		const entry = Object.entries(get().pendingByConversationId).find(
			([, candidate]) => candidate.requestId === requestId
		);

		if (!entry) {
			return undefined;
		}

		const [conversationId, pending] = entry;

		set((state) => ({
			pendingByConversationId: {
				...state.pendingByConversationId,
				[conversationId]: {
					...pending,
					accepted: true,
					expiresAt: new Date(
						Date.now() + ACCEPTED_RING_FALLBACK_MS
					).toISOString(),
				},
			},
		}));

		return conversationId;
	},
}));
